export default __webpack_public_path__ + "static/media/dashboard-quick-invest-icon.8544c0fc.svg";